module.exports = __webpack_public_path__ + "media/src/assets/Images/WebPng-986a491d30390484162a6cbc9854707d.png";